import { Component } from '@angular/core';
import { TextAreaWidget as _TextAreaWidget } from '../angular2-schema-form-shim';
import { JSONSchema } from '../types/json-schema';
import { isWidgetRequired } from './overrides';

@Component( {
  selector: 'sp-textarea-widget',
  templateUrl: './textarea.widget.html',
} )
export class TextAreaWidget extends _TextAreaWidget {
  schema: JSONSchema;

  get required() {
    return isWidgetRequired( this );
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/textarea.widget.ts